import { useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"
import usePatient from "@hooks/usePatient"
import { useState } from "react"
import { ViewPatientNotesIcon } from "@assets/icons/ViewPatientNotes"

// Import refactored components
import PatientHeader from "./components/PatientHeader"
import CommentHistory from "./components/CommentHistory"
import DiagnosisSection from "./components/DiagnosisSection"
import MetricsTable from "./components/MetricsTable"
import AddComment from "./components/AddComment"

const Notes = () => {
  const { patient } = useSelector((state) => state.patient)
  const [searchParams] = useSearchParams()
  const { handleGetSinglePatient } = usePatient()
  const patientId = searchParams.get("_id")
  const patientData = patient?.data[0]

  // Function to refresh patient data - will be passed to child components
  const refreshPatientData = () => {
    handleGetSinglePatient({ _id: patientId })
  }

  return (
    <>
      <div className="md:py-8 md:px-10 md:bg-[--pure-white] rounded-2xl flex flex-col">
        <div className="flex flex-col gap-6">
          {/* Patient header - full width */}
          <div>
            <PatientHeader patientData={patientData} />
          </div>

          {/* Grid layout with 70% | 30% division */}
          <div className="flex flex-col lg:flex-row gap-4">
            {/* Left section - 70% */}
            <div className="w-full lg:w-[70%] rounded-lg">
              <div className="mb-4">
                <DiagnosisSection
                  patientData={patientData}
                  patientId={patientId}
                  refreshPatientData={refreshPatientData}
                />
              </div>

              <div className="mb-4">
                <MetricsTable
                  patientData={patientData}
                  refreshPatientData={refreshPatientData}
                />
              </div>
            </div>

            {/* Right section - 30% */}
            <div className="w-full lg:w-[30%] rounded-lg">
              <div className="mb-4">
                <AddComment
                  patientId={patientId}
                  refreshPatientData={refreshPatientData}
                />
              </div>

              <div className="mb-4">
                <CommentHistory patientData={patientData} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Notes
